// redux/calendar_ICS/reducers.js

import {
    FETCH_ICS_REQUEST,
    FETCH_ICS_SUCCESS,
    FETCH_ICS_FAILURE,
  } from './constants';

const initialState = {
  loading: false,
  events: [],
  eventCategories: [],
  error: null,
};

const calendarReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ICS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_ICS_SUCCESS:
      return {
        ...state,
        loading: false,
        events: action.payload.events,
        eventCategories: action.payload.eventCategories,
        error: null,
      };
    case FETCH_ICS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error || 'An error occurred while fetching calendar data',
      };
    default:
      return state;
  }
};

export default calendarReducer;
